import ServicoTable from './ServicoTable';

export default ServicoTable;
